import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Nav from './components/Nav/Nav'
import Footer from './components/Footer/Footer'

const Layout = () => {

  const location = useLocation()
  const hideNavRoutes = ['/dashboard', '/adminlogin'];

  return (
    <div>
      
      {(!hideNavRoutes.includes(location.pathname) && (!location.pathname.startsWith('/viewapplication'))) && <Nav />}

      <Outlet />

      {(!hideNavRoutes.includes(location.pathname) && (!location.pathname.startsWith('/viewapplication'))) && <Footer />}

    </div>
  )
}

export default Layout
